import { Box } from '@mui/material';

import { SCHEDULE_ACTIVITY_COLORS, SCHEDULE_ACTIVITY_OPTIONS } from '../constants';
import { SCHEDULE_ACTIVITY_LEGEND_ITEM_SX, SCHEDULE_ACTIVITY_LEGEND_SX } from '../styles';

export default function ScheduleActivityLegend() {
  return (
    <Box sx={SCHEDULE_ACTIVITY_LEGEND_SX}>
      {SCHEDULE_ACTIVITY_OPTIONS.map((option) => (
        <Box
          key={option.value}
          sx={[
            SCHEDULE_ACTIVITY_LEGEND_ITEM_SX,
            { backgroundColor: SCHEDULE_ACTIVITY_COLORS[option.value] },
          ]}
        >
          {option.label}
        </Box>
      ))}
    </Box>
  );
}
